
export const DockTierDroOpts = () => {

    const getTierByItemList = () => {
        let items = [];
        items.push("1");
        items.push("2");
        items.push("3");

        return [
            ...(items?.map(value => ({
                dropdownLabel: value,
                tagLabel: value,
                value: value
            })) ?? [])];
    }


    return {
        getTierByItemList
    }
}